module.exports = __webpack_public_path__ + "couch_5.png?53d9e88fdc09fa50352aeeab78102c72";


//////////////////
// WEBPACK FOOTER
// ./assets/couch_5.png
// module id = 30
// module chunks = 0